export default __webpack_public_path__ + "static/poster-dbd47aa339592543768ef2c47e719e71.png";